module.exports = __webpack_public_path__ + "static/Q8Answer4_shapeofyou_designecologist-e95363e2094fde3146ff087fb6ee97b3.jpg";